import { render, staticRenderFns } from "./ProductClassTreeNodeTemplate.vue?vue&type=template&id=32193e0d&"
import script from "./ProductClassTreeNodeTemplate.vue?vue&type=script&lang=js&"
export * from "./ProductClassTreeNodeTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports